/**
 * Shared flag letting slot content of the unified-public layout (e.g. the auth flow while it
 * completes login and redirects) hide the public nav bar.
 *
 * Initialised hidden when the page loads mid-social-auth (social_flow query, see
 * useUnifiedAuthFlow): the auth flow immediately covers the page with a full-screen loader,
 * and the layout must agree with that on the server render — rendering the nav in SSR HTML
 * and hiding it client-side would be a hydration mismatch.
 */
export const useUnifiedPublicNavHidden = () => {
  const route = useRoute();
  return useState('unified-public-nav-hidden', () => !!route.query.social_flow);
};

/**
 * Shared flag asking the unified-public layout to keep its header bar but show only the logo,
 * the way the authed layout does. The auth flow sets it once the visitor is signed in mid-flow:
 * the public links no longer apply, and removing the bar outright would shift the card.
 */
export const useUnifiedPublicNavLogoOnly = () => useState('unified-public-nav-logo-only', () => false);
